import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { SyncLogIdentifier } from '../types';
import { SyncLogIntegrationApi, type SyncLogIntegrationApiContract } from './integration.api';

export interface SyncLogsApiContract {
  deleteAll(): Promise<void>;
  for(identifier: SyncLogIdentifier): SyncLogIntegrationApiContract;
}

export class SyncLogsApi extends ApiService implements SyncLogsApiContract {
  deleteAll(): Promise<void> {
    return this.api.proxy({
      method: 'DELETE',
      path: '/v1/sync-log',
    });
  }

  for(identifier: SyncLogIdentifier): SyncLogIntegrationApiContract {
    return new SyncLogIntegrationApi(this.api, identifier);
  }
}
